export function renderCell(dataItem, col) {
    const raw = dataItem[col.field];

    // 1) Null or undefined
    if (raw == null) {
        return renderNull();
    }

    // 2) “Object” rendering
    if (col.object) {
        const objResult = renderObjectCell(raw);
        if (objResult != null) return objResult;
    }

    // 3) “Options” rendering
    if (col.options) {
        const optResult = renderOptionCell(raw, col.options);
        if (optResult != null) return optResult;
    }

    // 4) Email list
    if (col.format === 'email') {
        const emailResult = renderEmailCell(raw);
        if (emailResult != null) return emailResult;
    }

    // 5) Fallback
    return raw;
}
export function renderNull() {
    return '-';
}

export function renderObjectCell(raw) {
    if (typeof raw === 'object' && raw.link) {
        return `<a class="theme-links" href="${raw.link}">${raw.value}</a>`;
    }
    return `<span>${raw}</span>`;
}

export function renderOptionCell(raw, options) {
    const isString = typeof raw === 'string';
    const norm     = isString ? raw.toLowerCase() : raw;

    const opt = options.find(o => {
        if (typeof o.value === 'string') {
            return norm === o.value.toLowerCase();
        }
        return raw === o.value;
    });

    if (!opt) return null;
    const display = isString
        ? raw.charAt(0).toUpperCase() + raw.slice(1)
        : raw;
    const badge = opt.badge;
    return badge
        ? `<span class="badge badge-${badge} text-white">${display}</span>`
        : `<span>${display}</span>`;
}

export function renderEmailCell(raw) {
    const emails = processEmails(raw);
    if (!emails.length) return null;
    return `<ul class="email-list">${
        emails.map(e => `<li>${e}</li>`).join('')
    }</ul>`;
}
export function processEmails(emailValue) {
    if (typeof emailValue === 'string' && emailValue.includes(',')) {
        return emailValue.split(',').map(email => email.trim());
    }
    return [emailValue];
}

export function formatActions(actions) {
    return Object.values(actions).map(action => ({
        label: action.label,
        value: action,
        icon: action.icon
    }));
}

